import MalattieInfettiveConfigurazioneUosdListPage from "./pages/MalattieInfettiveConfigurazioneUosdListPage.vue";

export default {
    MalattieInfettiveConfigurazioneUosdListPage,
};